import { render, staticRenderFns } from "./Slide8.vue?vue&type=template&id=5fc79602&scoped=true&"
import script from "./Slide8.vue?vue&type=script&lang=js&"
export * from "./Slide8.vue?vue&type=script&lang=js&"
import style0 from "./Slide8.vue?vue&type=style&index=0&id=5fc79602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc79602",
  null
  
)

export default component.exports